export default "__VITE_ASSET__u$BdYOhL__"